package com.yogaaicoach.pages.dashboard

import com.yogaaicoach.pages.auth.TokenData

sealed class DashboardMode {
    data object Locked : DashboardMode()
    data object NewUser : DashboardMode()
    data object NoActiveProgram : DashboardMode()
    data object TrainingCreationInProgress : DashboardMode()
    data object Ready : DashboardMode()
}

// Mirrors DashboardScreen.kt's resolveDashboardMode (composeApp), taking the same primitive
// inputs instead of the Compose-only DashboardScreenState wrapper.
fun resolveDashboardMode(
    dashboardItems: List<DashboardItem>,
    hasPreviousProgram: Boolean,
    isTrainingCreationInProgress: Boolean,
    tokenData: TokenData?
): DashboardMode {
    val isSubscribed = tokenData?.isSubscribed ?: false
    val freeTrialDaysLeft = tokenData?.freeTrialDaysLeft

    val trialExpired = !isSubscribed && (freeTrialDaysLeft == null || freeTrialDaysLeft <= 0)

    return when {
        trialExpired -> DashboardMode.Locked
        isTrainingCreationInProgress -> DashboardMode.TrainingCreationInProgress
        dashboardItems.isEmpty() && !hasPreviousProgram -> DashboardMode.NewUser
        dashboardItems.isEmpty() && hasPreviousProgram -> DashboardMode.NoActiveProgram
        else -> DashboardMode.Ready
    }
}
